import { ReactNode } from "react";
import "./EmptyState.scss";

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  height?: number | string;
  noBorder?: boolean;
}

const EmptyState = ({
  icon,
  title,
  subtitle,
  height,
  noBorder,
}: EmptyStateProps) => {
  return (
    <div
      className={`card empty-state${noBorder ? " empty-state--no-border" : ""}`}
      style={height ? { minHeight: height } : undefined}
    >
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">{title}</h3>
      {subtitle && <p className="empty-state-message">{subtitle}</p>}
    </div>
  );
};

export default EmptyState;
